import Swal from "sweetalert2";
import { getStringByTextKey } from "./getStringByTextKey";

export const customAlert = ({
  title,
  html = "html",
}: {
  title?: string;
  html: string;
}) => {
  Swal.fire({
    title,
    html,
    text: "test",
    icon: "info",
    confirmButtonText: `${getStringByTextKey("common.okBtn")}`,
    confirmButtonColor: "#2dd67c",
  });
};
